import { Routes } from '@angular/router';

import { TemplateResolverService } from '@services/template-resolver.service';
import { DocumentResolverService } from '@services/document-resolver.service';
import { TemplateListConfigurationResolverService } from '@services/template-list-configuration-resolver.service';
import { canDeactivateDocumentGuard, executeTemplateGuard, loginRouteGuard } from '../_core/guards';

export const applicationRoutes: Routes = [
  // -- Navigation für Templates
  {
    path: 'home',
    canActivate: [loginRouteGuard()],
    data: { breadcrumbLabel: 'Home' },
    loadComponent: () => import('./components/homepage/homepage.component').then(m => m.HomepageComponent)
  },
  {
    path: 'search',
    data: { breadcrumbLabel: 'Suche', setHistory: true },
    loadComponent: () => import('./components/search/search.component').then(m => m.SearchComponent)
  },
  {
    path: 'templates',
    data: { breadcrumbLabel: 'Dokumenttypen', setHistory: false },
    children: [
      {
        path: ':category',
        canActivate: [loginRouteGuard()],
        resolve: { configuration: TemplateListConfigurationResolverService },
        data: { breadcrumbLabel: 'Dokumenttypauswahl' },
        loadComponent: () => import('@dialogs/template-selector/template-selector.component').then(m => m.TemplateSelectorComponent)
      }
    ]
  },
  // -- Navigation für Template
  {
    path: 'template',
    data: { breadcrumbLabel: 'Erstellen', setHistory: false },
    children: [
      {
        path: ':templateid',
        canActivate: [loginRouteGuard(), executeTemplateGuard()],
        canDeactivate: [canDeactivateDocumentGuard()],
        resolve: { resolvedDocument: TemplateResolverService },
        data: { breadcrumbLabel: null, setHistory: false },
        loadComponent: () => import('./components/forms/document-base/document-base.component').then(m => m.DocumentBaseComponent)
      }
    ]
  },
  // -- Navigation für Dokumente
  {
    path: 'documents',
    data: { breadcrumbLabel: 'Dokumente' },
    canActivate: [loginRouteGuard()],
    children: [
      {
        path: 'task',
        data: { breadcrumbLabel: 'Aufgabenboard' },
        children: [
          {
            path: '',
            data: { breadcrumbLabel: 'Aufgabenboard', name: 'list' },
            loadComponent: () => import('./components/lists/taskboard-user/taskboard-user.component').then(m => m.TaskboardUserComponent)
          },
          {
            path: ':documentid',
            canDeactivate: [canDeactivateDocumentGuard()],
            resolve: { resolvedDocument: DocumentResolverService },
            data: { breadcrumbLabel: 'Dokumentinhalt', name: 'document-content', setHistory: false },
            loadComponent: () => import('./components/forms/document-base/document-base.component').then(m => m.DocumentBaseComponent)
          }
        ]
      },
      {
        path: ':type',
        data: { breadcrumbLabel: 'Ansicht', name: 'list' },
        loadComponent: () => import('./components/lists/dynamic-view/dynamic-view.component').then(m => m.DynamicViewComponent)
      },
      {
        path: ':type/:documentid',
        canDeactivate: [canDeactivateDocumentGuard()],
        resolve: { resolvedDocument: DocumentResolverService },
        data: { breadcrumbLabel: 'Dokumentinhalt', name: 'document-content', setHistory: true },
        loadComponent: () => import('./components/forms/document-base/document-base.component').then(m => m.DocumentBaseComponent)
      }
    ]
  },
  {
    path: 'create',
    data: { breadcrumbLabel: 'Erstellen', setHistory: false },
    children: [
      {
        path: ':name',
        canActivate: [loginRouteGuard()],
        data: { breadcrumbLabel: null, setHistory: false },
        loadComponent: () => import('./components/create/create.component').then(m => m.CreateComponent)
      }
    ]
  },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: '**', // unbekannte Routen führen zur LoginSeite
    loadComponent: () => import('@components/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent)
  }
];
